import { AddGiftCardModal } from 'components/gift-card-modal/add-gift-card';
import { AddGiftCardRedesign } from 'experiments/checkout-v2/control/pages/cart/payment/order-payment/add-gift-card-redesign/add-gift-card-redesign';
import { usePaymentCheckoutRedesignExperiment } from 'experiments/use-payment-checkout-redesign-experiment';

export default function AddGiftCard() {
  const isPaymentRedesignEnabled = usePaymentCheckoutRedesignExperiment();

  return isPaymentRedesignEnabled ? <AddGiftCardRedesign /> : <AddGiftCardModal />;
}
